export class HoardingQueryParams {
    hoardingId?: string;
    projection: string = 'hoardingGroupProjection';
}